// removed by extract-text-webpack-plugin
module.exports = {"content":"tO6Bcmh1"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/max-container/ums-max-container.styles.scss
// module id = 757
// module chunks = 0